import React from 'react';
import { useNavigation } from '../context/NavigationContext';

interface ButtonGroupProps {
  className?: string;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ className }) => {
  const { navigate } = useNavigation();

  const handleAiClick = () => {
    navigate('/mcp');
  };

  const handleChromeExtensionClick = () => {
    window.open('https://chromewebstore.google.com/detail/stashr/fkhhemhabdhaobakcooochcbpclmlifc', '_blank');
  };

  return (
    <div className={`button-group ${className || ''}`}>
      <button
        onClick={handleAiClick}
        className="primary-button mcp-button white-color"
      >
        Claude, ChatGPT &amp; Gemini
      </button>
      <button
        onClick={handleChromeExtensionClick}
        className="primary-button chrome-button white-color"
      >
        Chrome Extension
      </button>
    </div>
  );
};

export default ButtonGroup;
